import styled from '@emotion/styled';
import { semantic_colors } from '../../foundation';
import { CSSValueWithLength, buildCSSWithLength } from '../../styles';

export type direction = 'horizontal' | 'vertical';
export type DividerSize = 'small' | 'medium';

export interface DividerProps {
  /** @default 'horizontal' */
  direction?: direction;
  /**
   * 간격을 설정할 수 있습니다.
   *  - direction horizontal 일경우 상하 간격에 적용됩니다.
   *  - direction vertical 일경우 좌우 간격에 적용됩니다.
   */
  spacing?: CSSValueWithLength;
  /** @default 'small' */
  size?: DividerSize;
  /**
   * border color를 지정할 수 있습니다.
   *  - 지정하지 않을 경우 size medium 일경우 semantic_colors.background.base로 적용됩니다.
   *  - 지정하지 않을 경우 size small 일경우 semantic_colors.border.primary로 적용됩니다.
   * @default semantic_colors.border.primary
   */
  color?: string;
  /**
   * 지정된 길이를 설정할 수 있습니다.
   *  - 지정하지 않을 경우 direction horizontal 이라면 width 값이 100%로 고정됩니다.
   *  - 지정하지 않을 경우 direction vertical 이라면 height값이 100%로 고정됩니다.
   * @default '100%'
   */
  length?: CSSValueWithLength;
}

export const Divider = styled.hr<DividerProps>`
  overflow: visible;
  border: 0;
  margin: 0;

  ${({ direction, size, length, color }) => {
    const defaultDirection = direction === 'horizontal';
    const dividerSize = {
      small: 1,
      medium: 8,
    };
    const dividerLength = length ?? '100%';

    return `
      background-color: ${
        color ? color : size === 'medium' ? semantic_colors.background.base : semantic_colors.border.primary
      };
      ${buildCSSWithLength('width', defaultDirection ? dividerLength : dividerSize[size ?? 'small'])};
      ${buildCSSWithLength('height', defaultDirection ? dividerSize[size ?? 'small'] : dividerLength)};
    `;
  }}

  ${({ direction, spacing }) =>
    spacing &&
    `
      ${direction === 'horizontal' ? `margin: ${spacing}px 0` : `margin: 0 ${spacing}px`};
    `}
`;

Divider.defaultProps = {
  size: 'small',
  direction: 'horizontal',
};
